import { useMemo } from "react";
import { useAuth } from "../context/AuthContext";

export function useAutomationsApi() {
  const { apiFetch } = useAuth();

  return useMemo(
    () => ({
      catalog: () => apiFetch("/automations/catalog"),

      getAll: () => apiFetch("/automations"),

      create: (data) =>
        apiFetch("/automations", { method: "POST", body: JSON.stringify(data) }),

      update: (id, data) =>
        apiFetch(`/automations/${id}`, { method: "PUT", body: JSON.stringify(data) }),

      setEnabled: (id, enabled, confirmExternal) =>
        apiFetch(`/automations/${id}/enabled`, {
          method: "PATCH",
          body: JSON.stringify({ enabled, confirmExternal }),
        }),

      remove: (id) => apiFetch(`/automations/${id}`, { method: "DELETE" }),

      simulate: (data) =>
        apiFetch("/automations/simulate", { method: "POST", body: JSON.stringify(data) }),

      runs: (automationId) =>
        apiFetch(`/automations/runs${automationId ? `?automationId=${automationId}` : ""}`),

      listEndpoints: () => apiFetch("/automations/endpoints"),

      createEndpoint: (data) =>
        apiFetch("/automations/endpoints", { method: "POST", body: JSON.stringify(data) }),

      setEndpointEnabled: (id, enabled) =>
        apiFetch(`/automations/endpoints/${id}/enabled`, {
          method: "PATCH",
          body: JSON.stringify({ enabled }),
        }),

      removeEndpoint: (id) =>
        apiFetch(`/automations/endpoints/${id}`, { method: "DELETE" }),

      deliveries: () => apiFetch("/automations/endpoints/deliveries"),
    }),
    [apiFetch],
  );
}
